import { Volume2, VolumeX } from "lucide-react";
import type { Preferences, ThemeMode } from "../types/preferences";

export function SettingsPanel({
  prefs,
  onChange,
}: {
  prefs: Preferences;
  onChange: (patch: Partial<Preferences>) => void;
}) {
  return (
    <section className="settings-panel">
      <div className="panel-heading">
        <span className="eyebrow">Einstellungen</span>
        <h2>Sound, Darstellung und Barrierefreiheit.</h2>
      </div>

      <div className="setting-row">
        <div className="setting-label">
          {prefs.sound ? <Volume2 size={18} /> : <VolumeX size={18} />}
          <div>
            <strong>Sound</strong>
            <small>Dezente Toene im Antwort-Moment. Bleibt aus, bis du ihn aktivierst.</small>
          </div>
        </div>
        <button
          aria-checked={prefs.sound}
          aria-label="Sound"
          className={`toggle ${prefs.sound ? "is-on" : ""}`}
          onClick={() => onChange({ sound: !prefs.sound })}
          role="switch"
          type="button"
        >
          <span className="toggle-knob" />
        </button>
      </div>

      <fieldset className="setting-row" aria-label="Darstellung">
        <legend className="setting-label">
          <strong>Darstellung</strong>
        </legend>
        <div className="setting-control-group">
          {(["dark", "light"] as ThemeMode[]).map((mode) => (
            <button
              className={`chip ${prefs.theme === mode ? "is-active" : ""}`}
              key={mode}
              onClick={() => onChange({ theme: mode })}
              type="button"
            >
              {mode === "dark" ? "Dossier Nacht" : "Dossier Papier"}
            </button>
          ))}
        </div>
      </fieldset>

      <fieldset className="setting-row" aria-label="Bewegung">
        <legend className="setting-label">
          <strong>Animationen reduzieren</strong>
        </legend>
        <button
          aria-checked={prefs.reducedMotion === true}
          aria-label="Animationen reduzieren"
          className={`toggle ${prefs.reducedMotion ? "is-on" : ""}`}
          onClick={() => onChange({ reducedMotion: prefs.reducedMotion ? null : true })}
          role="switch"
          type="button"
        >
          <span className="toggle-knob" />
        </button>
      </fieldset>
    </section>
  );
}
